<template>
   <div class="slider-actions">
      <nuxt-link v-if="link" :to="link" class="grey">View All</nuxt-link>

      <!-- arrows -->
      <div class="arrows">
         <div
            class="prev"
            :class="[{ disabled: progress == 0 }]"
            @click="emit('previous')"
         >
            <IconArrowLeft />
         </div>
         <div
            class="next"
            :class="[{ disabled: progress == 1 }]"
            @click="emit('next')"
         >
            <IconArrowRight />
         </div>
      </div>
   </div>
</template>

<script setup lang="ts">
import IconArrowRight from "~/assets/images/icons/arrow-right.svg?component";
import IconArrowLeft from "~/assets/images/icons/arrow-left.svg?component";
const emit = defineEmits(["previous", "next"]);
const props = defineProps({
   link: { type: String, default: null },
   progress: { type: Number, default: 0 },
});
</script>

<style lang="scss" scoped>
div.slider-actions {
   display: inline-flex;
   align-items: center;
   column-gap: pad(2);

   div.arrows {
      display: inline-flex;
      column-gap: pad(.5);
      cursor: pointer;
      > div {
         height: 32px;
         width: 32px;
         border-radius: 4px;
         display: flex;
         justify-content: center;
         align-items: center;
         transition: all 0.2s;
         background-color: $hover-background-lt;
         border:1px solid color.adjust($background, $lightness: -5%);
         &.disabled{
            pointer-events: none;
            opacity: .5;
         }
         &:hover {
            background-color: $hover-background;
            border:1px solid  $hover-background;
         }
      }
   }
   a {
      &:hover {
         color: $black;
      }
   }
}
</style>
